/**
 * @generated SignedSource<<a90502d872b9a1f054a87801ea9928a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeoRouteType = "ALIAS" | "PERMANENT_REDIRECT" | "REDIRECT";
export type UpdateSeoRouteInput = {
  h1?: string | null;
  metaDescription?: string | null;
  metaTitle?: string | null;
  promoLinkTitle?: string | null;
  promoLinkUrl?: string | null;
  promoText?: string | null;
  sourceUrl?: string | null;
  targetUrl?: string | null;
  type?: SeoRouteType | null;
};
export type SeoRouteEditFormMutation$variables = {
  id: string;
  input: UpdateSeoRouteInput;
};
export type SeoRouteEditFormMutation$data = {
  readonly updateSeoRoute: {
    readonly " $fragmentSpreads": FragmentRefs<"SeoRouteEditForm_seoRoute" | "SeoRouteSidebar_seoRoute">;
  };
};
export type SeoRouteEditFormMutation = {
  response: SeoRouteEditFormMutation$data;
  variables: SeoRouteEditFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SeoRouteEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SeoRoute",
        "kind": "LinkedField",
        "name": "updateSeoRoute",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SeoRouteSidebar_seoRoute"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SeoRouteEditForm_seoRoute"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SeoRouteEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SeoRoute",
        "kind": "LinkedField",
        "name": "updateSeoRoute",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SeoRouteJsonParam",
            "kind": "LinkedField",
            "name": "jsonParams",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "62c27386e525d948955ae5224ce1eedd",
    "id": null,
    "metadata": {},
    "name": "SeoRouteEditFormMutation",
    "operationKind": "mutation",
    "text": "mutation SeoRouteEditFormMutation(\n  $id: ID!\n  $input: UpdateSeoRouteInput!\n) {\n  updateSeoRoute(id: $id, input: $input) {\n    ...SeoRouteSidebar_seoRoute\n    ...SeoRouteEditForm_seoRoute\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment SeoRouteEditForm_seoRoute on SeoRoute {\n  id\n  type\n  sourceUrl\n  targetUrl\n}\n\nfragment SeoRouteJsonParams_seoRoute on SeoRoute {\n  jsonParams {\n    name\n    value\n  }\n}\n\nfragment SeoRouteSidebar_seoRoute on SeoRoute {\n  jsonParams {\n    name\n  }\n  ...EntitySidebar_entity\n  ...SeoRouteJsonParams_seoRoute\n}\n"
  }
};
})();

(node as any).hash = "4ec9b3fe31e904d85c79b04617a9049e";

export default node;
